import Splide from "@splidejs/splide";
var GallerySlider = /** @class */ (function () {
    function GallerySlider() {
        this.slider = null;
        this.hasVideo = false;
        this.currentVideo = null;
        this.autoplayPaused = false;
        this.init();
    }
    GallerySlider.prototype.init = function () {
        var sliderElement = document.getElementById("gallery-slider");
        if (!sliderElement)
            return;
        // Check if gallery has videos
        this.hasVideo = sliderElement.dataset.hasVideo === "true";
        this.slider = new Splide("#gallery-slider", {
            type: "loop",
            perPage: 1,
            perMove: 1,
            gap: "0",
            arrows: true,
            pagination: true,
            autoplay: true,
            interval: 6000,
            pauseOnHover: true,
            speed: 800,
            easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        });
        this.slider.mount();
        // Initialize video controls if gallery has videos
        if (this.hasVideo) {
            this.initVideoControls();
        }
    };
    GallerySlider.prototype.initVideoControls = function () {
        var _this = this;
        if (!this.slider)
            return;
        // Handle slide change - pause any playing video
        this.slider.on("move", function () {
            _this.pauseAllVideos();
        });
        // Set up play buttons
        var playButtons = document.querySelectorAll(".gallery-slider__play-btn");
        playButtons.forEach(function (btn) {
            btn.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                var slide = btn.closest(".splide__slide");
                var video = slide === null || slide === void 0 ? void 0 : slide.querySelector(".gallery-slider__video");
                if (video) {
                    _this.playVideo(video, slide);
                }
            });
        });
        // Set up video end handlers
        var videos = document.querySelectorAll(".gallery-slider__video");
        videos.forEach(function (video) {
            video.addEventListener("ended", function () {
                _this.onVideoEnded(video);
            });
            // Click on video to pause
            video.addEventListener("click", function () {
                if (!video.paused) {
                    _this.pauseVideo(video);
                }
            });
        });
    };
    GallerySlider.prototype.playVideo = function (video, slide) {
        // Pause any other playing video
        this.pauseAllVideos();
        // Play this video
        video.play();
        this.currentVideo = video;
        slide.classList.add("is-playing");
        this.autoplayPaused = true;
    };
    GallerySlider.prototype.pauseVideo = function (video) {
        video.pause();
        var slide = video.closest(".splide__slide");
        slide === null || slide === void 0 ? void 0 : slide.classList.remove("is-playing");
        if (this.currentVideo === video) {
            this.currentVideo = null;
            this.autoplayPaused = false;
        }
    };
    GallerySlider.prototype.pauseAllVideos = function () {
        var videos = document.querySelectorAll(".gallery-slider__video");
        videos.forEach(function (video) {
            if (!video.paused) {
                video.pause();
                video.currentTime = 0;
                var slide = video.closest(".splide__slide");
                slide === null || slide === void 0 ? void 0 : slide.classList.remove("is-playing");
            }
        });
        this.currentVideo = null;
        this.autoplayPaused = false;
    };
    GallerySlider.prototype.onVideoEnded = function (video) {
        var _a;
        var slide = video.closest(".splide__slide");
        slide === null || slide === void 0 ? void 0 : slide.classList.remove("is-playing");
        video.currentTime = 0;
        this.currentVideo = null;
        this.autoplayPaused = false;
        // Go to next slide
        (_a = this.slider) === null || _a === void 0 ? void 0 : _a.go(">");
    };
    return GallerySlider;
}());
export { GallerySlider };
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
        new GallerySlider();
    });
}
else {
    new GallerySlider();
}
